module.exports = __webpack_public_path__ + "static/media/BG.c4afc18b.png";


//////////////////
// WEBPACK FOOTER
// ./src/invitation/invitationOpen/image/BG.png
// module id = 999
// module chunks = 0